export const selectorTranslations = {
  /** 国内版（仅简体中文） */
  zh: {
    selectorTrigger: "获取专属打印方案",
    selectorFabTeaserTitle: "👋 不知道选哪款打印机？",
    selectorFabTeaserSubtitle: "30分钟内获取专属推荐",
    selectorTitle: "不知道该选择哪款打印机？",
    selectorSubtitle:
      "填写您的需求，我们将在30分钟内为您推荐最适合的设备方案。",
    selectorProductLabel: "您想打印什么产品？",
    selectorProductPlaceholder: "请输入产品类型",
    selectorProductHint:
      "例如：手机壳、保温杯、亚克力、玻璃、金属、行李箱、标签贴纸、服装",
    selectorSizeLabel: "您的产品尺寸？",
    selectorSizePlaceholder: "请输入产品尺寸",
    selectorSizeHint: "例如：20×30cm、A3、A2、直径80mm、500×700mm",
    selectorOutputLabel: "预计日产量？",
    selectorOutput1: "1－50件",
    selectorOutput2: "50－200件",
    selectorOutput3: "200－500件",
    selectorOutput4: "500－1000件",
    selectorOutput5: "1000件以上",
    selectorBudgetLabel: "预算范围？",
    selectorBudget1: "2万元以内",
    selectorBudget2: "2万－5万元",
    selectorBudget3: "5万－10万元",
    selectorBudget4: "10万元以上",
    selectorBudget5: "暂未确定",
    selectorSelectPlaceholder: "请选择",
    selectorSubmit: "获取推荐方案",
    selectorSubmitting: "提交中…",
    selectorSubmitError: "提交失败，请稍后重试或直接联系我们。",
    selectorSuccessTitle: "感谢提交需求！",
    selectorSuccessDesc:
      "我们的顾问将在30分钟内联系您，并提供：",
    selectorSuccessItem1: "推荐机型",
    selectorSuccessItem2: "配置建议",
    selectorSuccessItem3: "样品案例",
    selectorSuccessItem4: "运费估算",
    selectorSuccessItem5: "报价方案",
    selectorClose: "关闭",
  },
  /** 国外版：与 English 内容一致，仅语言不同 */
  en: {
    selectorTrigger: "Get Your Printing Solution",
    selectorFabTeaserTitle: "Need help choosing a printer?",
    selectorFabTeaserSubtitle: "Get a recommendation within 30 minutes",
    selectorFabTeaserCta: "Start Now",
    selectorTitle: "Find the Right Printer for Your Business",
    selectorSubtitle:
      "Tell us your application, production volume and budget,\nand our experts will recommend the most suitable solution within 30 minutes.",
    selectorProductLabel: "What products would you like to print?",
    selectorProductPlaceholder: "Enter product type",
    selectorProductHint:
      "e.g. phone cases, tumblers, glass, acrylic, metal, luggage",
    selectorSizeLabel: "Product Dimensions",
    selectorSizePlaceholder: "Enter product dimensions",
    selectorSizeHint: "e.g. 20×30cm, A3, A2, 80mm diameter",
    selectorOutputLabel: "Estimated daily output?",
    selectorOutput1: "1–50 pieces",
    selectorOutput2: "50–200 pieces",
    selectorOutput3: "200–500 pieces",
    selectorOutput4: "500–1,000 pieces",
    selectorOutput5: "1,000+ pieces",
    selectorBudgetLabel: "Budget Range",
    selectorBudget1: "Below USD 3,000",
    selectorBudget2: "USD 3,000–6,000",
    selectorBudget3: "USD 6,000–10,000",
    selectorBudget4: "USD 10,000–20,000",
    selectorBudget5: "Above USD 20,000",
    selectorBudget6: "Not decided yet",
    selectorSelectPlaceholder: "Please select",
    selectorSubmit: "Get My Recommendation",
    selectorSubmitting: "Submitting…",
    selectorSubmitError: "Submission failed. Please try again or contact us directly.",
    selectorTrustBadge: "Trusted by customers in 172 countries",
    selectorTrustDelivered: "53,000+ Printers Delivered Worldwide",
    selectorSuccessTitle: "Thank you!",
    selectorSuccessDesc: "Our consultant will contact you within 30 minutes.",
    selectorSuccessReceive: "You will receive:",
    selectorSuccessItem1: "Recommended printer model",
    selectorSuccessItem2: "Configuration suggestions",
    selectorSuccessItem3: "Application samples",
    selectorSuccessItem4: "Shipping estimate",
    selectorSuccessItem5: "Quotation",
    selectorClose: "Close",
  },
  de: {
    selectorTrigger: "Ihre Drucklösung erhalten",
    selectorFabTeaserTitle: "Hilfe bei der Druckerwahl?",
    selectorFabTeaserSubtitle: "Empfehlung innerhalb von 30 Minuten",
    selectorFabTeaserCta: "Jetzt starten",
    selectorTitle: "Finden Sie den richtigen Drucker für Ihr Geschäft",
    selectorSubtitle:
      "Teilen Sie uns Ihre Anwendung, Produktionsmenge und Ihr Budget mit,\nund unsere Experten empfehlen innerhalb von 30 Minuten die passendste Lösung.",
    selectorProductLabel: "Welche Produkte möchten Sie drucken?",
    selectorProductPlaceholder: "Produkttyp eingeben",
    selectorProductHint:
      "z. B. Handyhüllen, Thermobecher, Glas, Acryl, Metall, Koffer",
    selectorSizeLabel: "Produktabmessungen",
    selectorSizePlaceholder: "Abmessungen eingeben",
    selectorSizeHint: "z. B. 20×30 cm, A3, A2, 80 mm Durchmesser",
    selectorOutputLabel: "Geschätzte Tagesproduktion?",
    selectorOutput1: "1–50 Stück",
    selectorOutput2: "50–200 Stück",
    selectorOutput3: "200–500 Stück",
    selectorOutput4: "500–1.000 Stück",
    selectorOutput5: "Über 1.000 Stück",
    selectorBudgetLabel: "Budgetrahmen?",
    selectorBudget1: "Unter 3.000 USD",
    selectorBudget2: "3.000–6.000 USD",
    selectorBudget3: "6.000–10.000 USD",
    selectorBudget4: "Über 10.000 USD",
    selectorBudget5: "Noch nicht festgelegt",
    selectorSelectPlaceholder: "Bitte wählen",
    selectorSubmit: "Empfehlung erhalten",
    selectorSubmitting: "Wird gesendet…",
    selectorSubmitError: "Senden fehlgeschlagen. Bitte später erneut versuchen oder kontaktieren Sie uns.",
    selectorTrustBadge: "Vertraut von Kunden in 172 Ländern",
    selectorTrustDelivered: "53.000+ Drucker weltweit ausgeliefert",
    selectorSuccessTitle: "Vielen Dank!",
    selectorSuccessDesc: "Unser Berater kontaktiert Sie innerhalb von 30 Minuten.",
    selectorSuccessReceive: "Sie erhalten:",
    selectorSuccessItem1: "Empfohlenes Druckermodell",
    selectorSuccessItem2: "Konfigurationsvorschläge",
    selectorSuccessItem3: "Anwendungsbeispiele",
    selectorSuccessItem4: "Versandschätzung",
    selectorSuccessItem5: "Angebot",
    selectorClose: "Schließen",
  },
  pt: {
    selectorTrigger: "Obtenha sua solução de impressão",
    selectorFabTeaserTitle: "Precisa de ajuda para escolher uma impressora?",
    selectorFabTeaserSubtitle: "Recomendação em 30 minutos",
    selectorFabTeaserCta: "Começar agora",
    selectorTitle: "Encontre a impressora certa para o seu negócio",
    selectorSubtitle:
      "Conte-nos sua aplicação, volume de produção e orçamento,\ne nossos especialistas recomendarão a solução mais adequada em 30 minutos.",
    selectorProductLabel: "Quais produtos você gostaria de imprimir?",
    selectorProductPlaceholder: "Digite o tipo de produto",
    selectorProductHint:
      "ex.: capas de celular, garrafas térmicas, vidro, acrílico, metal, malas",
    selectorSizeLabel: "Dimensões do produto",
    selectorSizePlaceholder: "Digite as dimensões",
    selectorSizeHint: "ex.: 20×30 cm, A3, A2, diâmetro 80 mm",
    selectorOutputLabel: "Produção diária estimada?",
    selectorOutput1: "1–50 peças",
    selectorOutput2: "50–200 peças",
    selectorOutput3: "200–500 peças",
    selectorOutput4: "500–1.000 peças",
    selectorOutput5: "Mais de 1.000 peças",
    selectorBudgetLabel: "Faixa de orçamento?",
    selectorBudget1: "Até USD 3.000",
    selectorBudget2: "USD 3.000–6.000",
    selectorBudget3: "USD 6.000–10.000",
    selectorBudget4: "Acima de USD 10.000",
    selectorBudget5: "Ainda não definido",
    selectorSelectPlaceholder: "Selecione",
    selectorSubmit: "Obter recomendação",
    selectorSubmitting: "Enviando…",
    selectorSubmitError: "Falha no envio. Tente novamente mais tarde ou fale conosco.",
    selectorTrustBadge: "Confiado por clientes em 172 países",
    selectorTrustDelivered: "53.000+ impressoras entregues em todo o mundo",
    selectorSuccessTitle: "Obrigado!",
    selectorSuccessDesc: "Nosso consultor entrará em contato em 30 minutos.",
    selectorSuccessReceive: "Você receberá:",
    selectorSuccessItem1: "Modelo de impressora recomendado",
    selectorSuccessItem2: "Sugestões de configuração",
    selectorSuccessItem3: "Amostras de aplicação",
    selectorSuccessItem4: "Estimativa de envio",
    selectorSuccessItem5: "Orçamento",
    selectorClose: "Fechar",
  },
  es: {
    selectorTrigger: "Obtenga su solución de impresión",
    selectorFabTeaserTitle: "¿Necesita ayuda para elegir una impresora?",
    selectorFabTeaserSubtitle: "Recomendación en 30 minutos",
    selectorFabTeaserCta: "Empezar ahora",
    selectorTitle: "Encuentre la impresora adecuada para su negocio",
    selectorSubtitle:
      "Cuéntenos su aplicación, volumen de producción y presupuesto,\ny nuestros expertos recomendarán la solución más adecuada en 30 minutos.",
    selectorProductLabel: "¿Qué productos le gustaría imprimir?",
    selectorProductPlaceholder: "Ingrese el tipo de producto",
    selectorProductHint:
      "ej.: fundas de móvil, termos, vidrio, acrílico, metal, maletas",
    selectorSizeLabel: "Dimensiones del producto",
    selectorSizePlaceholder: "Ingrese las dimensiones",
    selectorSizeHint: "ej.: 20×30 cm, A3, A2, diámetro 80 mm",
    selectorOutputLabel: "¿Producción diaria estimada?",
    selectorOutput1: "1–50 piezas",
    selectorOutput2: "50–200 piezas",
    selectorOutput3: "200–500 piezas",
    selectorOutput4: "500–1.000 piezas",
    selectorOutput5: "Más de 1.000 piezas",
    selectorBudgetLabel: "¿Rango de presupuesto?",
    selectorBudget1: "Menos de USD 3.000",
    selectorBudget2: "USD 3.000–6.000",
    selectorBudget3: "USD 6.000–10.000",
    selectorBudget4: "Más de USD 10.000",
    selectorBudget5: "Aún no definido",
    selectorSelectPlaceholder: "Seleccione",
    selectorSubmit: "Obtener recomendación",
    selectorSubmitting: "Enviando…",
    selectorSubmitError: "Error al enviar. Inténtelo de nuevo más tarde o contáctenos.",
    selectorTrustBadge: "Con la confianza de clientes en 172 países",
    selectorTrustDelivered: "53.000+ impresoras entregadas en todo el mundo",
    selectorSuccessTitle: "¡Gracias!",
    selectorSuccessDesc: "Nuestro asesor le contactará en 30 minutos.",
    selectorSuccessReceive: "Recibirá:",
    selectorSuccessItem1: "Modelo de impresora recomendado",
    selectorSuccessItem2: "Sugerencias de configuración",
    selectorSuccessItem3: "Muestras de aplicación",
    selectorSuccessItem4: "Estimación de envío",
    selectorSuccessItem5: "Cotización",
    selectorClose: "Cerrar",
  },
  fr: {
    selectorTrigger: "Obtenez votre solution d'impression",
    selectorFabTeaserTitle: "Besoin d'aide pour choisir une imprimante ?",
    selectorFabTeaserSubtitle: "Recommandation en 30 minutes",
    selectorFabTeaserCta: "Commencer",
    selectorTitle: "Trouvez la bonne imprimante pour votre entreprise",
    selectorSubtitle:
      "Indiquez-nous votre application, votre volume de production et votre budget,\net nos experts recommanderont la solution la plus adaptée sous 30 minutes.",
    selectorProductLabel: "Quels produits souhaitez-vous imprimer ?",
    selectorProductPlaceholder: "Saisissez le type de produit",
    selectorProductHint:
      "ex. : coques, gobelets, verre, acrylique, métal, valises",
    selectorSizeLabel: "Dimensions du produit",
    selectorSizePlaceholder: "Saisissez les dimensions",
    selectorSizeHint: "ex. : 20×30 cm, A3, A2, diamètre 80 mm",
    selectorOutputLabel: "Production quotidienne estimée ?",
    selectorOutput1: "1–50 pièces",
    selectorOutput2: "50–200 pièces",
    selectorOutput3: "200–500 pièces",
    selectorOutput4: "500–1 000 pièces",
    selectorOutput5: "Plus de 1 000 pièces",
    selectorBudgetLabel: "Fourchette budgétaire ?",
    selectorBudget1: "Moins de 3 000 USD",
    selectorBudget2: "3 000–6 000 USD",
    selectorBudget3: "6 000–10 000 USD",
    selectorBudget4: "Plus de 10 000 USD",
    selectorBudget5: "Pas encore décidé",
    selectorSelectPlaceholder: "Veuillez sélectionner",
    selectorSubmit: "Obtenir une recommandation",
    selectorSubmitting: "Envoi…",
    selectorSubmitError: "Échec de l’envoi. Réessayez plus tard ou contactez-nous.",
    selectorTrustBadge: "Approuvé par des clients dans 172 pays",
    selectorTrustDelivered: "53 000+ imprimantes livrées dans le monde",
    selectorSuccessTitle: "Merci !",
    selectorSuccessDesc: "Notre conseiller vous contactera sous 30 minutes.",
    selectorSuccessReceive: "Vous recevrez :",
    selectorSuccessItem1: "Modèle d'imprimante recommandé",
    selectorSuccessItem2: "Suggestions de configuration",
    selectorSuccessItem3: "Exemples d'application",
    selectorSuccessItem4: "Estimation d'expédition",
    selectorSuccessItem5: "Devis",
    selectorClose: "Fermer",
  },
  it: {
    selectorTrigger: "Ottieni la tua soluzione di stampa",
    selectorFabTeaserTitle: "Hai bisogno di aiuto per scegliere una stampante?",
    selectorFabTeaserSubtitle: "Consiglio entro 30 minuti",
    selectorFabTeaserCta: "Inizia ora",
    selectorTitle: "Trova la stampante giusta per la tua attività",
    selectorSubtitle:
      "Indicaci applicazione, volume di produzione e budget,\ne i nostri esperti ti consiglieranno la soluzione più adatta entro 30 minuti.",
    selectorProductLabel: "Quali prodotti vorresti stampare?",
    selectorProductPlaceholder: "Inserisci il tipo di prodotto",
    selectorProductHint:
      "es.: cover, borracce, vetro, acrilico, metallo, valigie",
    selectorSizeLabel: "Dimensioni del prodotto",
    selectorSizePlaceholder: "Inserisci le dimensioni",
    selectorSizeHint: "es.: 20×30 cm, A3, A2, diametro 80 mm",
    selectorOutputLabel: "Produzione giornaliera stimata?",
    selectorOutput1: "1–50 pezzi",
    selectorOutput2: "50–200 pezzi",
    selectorOutput3: "200–500 pezzi",
    selectorOutput4: "500–1.000 pezzi",
    selectorOutput5: "Oltre 1.000 pezzi",
    selectorBudgetLabel: "Fascia di budget?",
    selectorBudget1: "Meno di 3.000 USD",
    selectorBudget2: "3.000–6.000 USD",
    selectorBudget3: "6.000–10.000 USD",
    selectorBudget4: "Oltre 10.000 USD",
    selectorBudget5: "Non ancora deciso",
    selectorSelectPlaceholder: "Seleziona",
    selectorSubmit: "Ottieni consiglio",
    selectorSubmitting: "Invio…",
    selectorSubmitError: "Invio non riuscito. Riprova più tardi o contattaci.",
    selectorTrustBadge: "Scelto da clienti in 172 paesi",
    selectorTrustDelivered: "53.000+ stampanti consegnate in tutto il mondo",
    selectorSuccessTitle: "Grazie!",
    selectorSuccessDesc: "Il nostro consulente ti contatterà entro 30 minuti.",
    selectorSuccessReceive: "Riceverai:",
    selectorSuccessItem1: "Modello di stampante consigliato",
    selectorSuccessItem2: "Suggerimenti di configurazione",
    selectorSuccessItem3: "Campioni applicativi",
    selectorSuccessItem4: "Stima di spedizione",
    selectorSuccessItem5: "Preventivo",
    selectorClose: "Chiudi",
  },
  hi: {
    selectorTrigger: "अपना प्रिंटिंग समाधान प्राप्त करें",
    selectorFabTeaserTitle: "प्रिंटर चुनने में मदद चाहिए?",
    selectorFabTeaserSubtitle: "30 मिनट में सिफारिश पाएं",
    selectorFabTeaserCta: "अभी शुरू करें",
    selectorTitle: "अपने व्यवसाय के लिए सही प्रिंटर खोजें",
    selectorSubtitle:
      "अपना अनुप्रयोग, उत्पादन मात्रा और बजट बताएं,\nऔर हमारे विशेषज्ञ 30 मिनट में सबसे उपयुक्त समाधान की सिफारिश करेंगे।",
    selectorProductLabel: "आप कौन से उत्पाद प्रिंट करना चाहेंगे?",
    selectorProductPlaceholder: "उत्पाद प्रकार दर्ज करें",
    selectorProductHint:
      "जैसे: फोन केस, टंबलर, ग्लास, एक्रिलिक, धातु, सामान",
    selectorSizeLabel: "उत्पाद आयाम",
    selectorSizePlaceholder: "आयाम दर्ज करें",
    selectorSizeHint: "जैसे: 20×30cm, A3, A2, 80mm व्यास",
    selectorOutputLabel: "अनुमानित दैनिक उत्पादन?",
    selectorOutput1: "1–50 टुकड़े",
    selectorOutput2: "50–200 टुकड़े",
    selectorOutput3: "200–500 टुकड़े",
    selectorOutput4: "500–1,000 टुकड़े",
    selectorOutput5: "1,000+ टुकड़े",
    selectorBudgetLabel: "बजट सीमा?",
    selectorBudget1: "3,000 USD से कम",
    selectorBudget2: "3,000–6,000 USD",
    selectorBudget3: "6,000–10,000 USD",
    selectorBudget4: "10,000 USD से अधिक",
    selectorBudget5: "अभी तय नहीं",
    selectorSelectPlaceholder: "कृपया चुनें",
    selectorSubmit: "सुझाव प्राप्त करें",
    selectorSubmitting: "भेजा जा रहा है…",
    selectorSubmitError: "सबमिट विफल। बाद में पुनः प्रयास करें या हमसे संपर्क करें।",
    selectorTrustBadge: "172 देशों के ग्राहकों द्वारा विश्वसनीय",
    selectorTrustDelivered: "53,000+ प्रिंटर विश्वभर में वितरित",
    selectorSuccessTitle: "धन्यवाद!",
    selectorSuccessDesc: "हमारा सलाहकार 30 मिनट में संपर्क करेगा।",
    selectorSuccessReceive: "आपको मिलेगा:",
    selectorSuccessItem1: "अनुशंसित प्रिंटर मॉडल",
    selectorSuccessItem2: "कॉन्फ़िगरेशन सुझाव",
    selectorSuccessItem3: "अनुप्रयोग नमूने",
    selectorSuccessItem4: "शिपिंग अनुमान",
    selectorSuccessItem5: "कोटेशन",
    selectorClose: "बंद करें",
  },
  ru: {
    selectorTrigger: "Получите решение для печати",
    selectorFabTeaserTitle: "Нужна помощь с выбором принтера?",
    selectorFabTeaserSubtitle: "Рекомендация за 30 минут",
    selectorFabTeaserCta: "Начать",
    selectorTitle: "Найдите подходящий принтер для вашего бизнеса",
    selectorSubtitle:
      "Расскажите о применении, объёме производства и бюджете,\nи наши эксперты подберут оптимальное решение в течение 30 минут.",
    selectorProductLabel: "Какие продукты вы хотели бы печатать?",
    selectorProductPlaceholder: "Введите тип продукта",
    selectorProductHint:
      "напр.: чехлы, термокружки, стекло, акрил, металл, чемоданы",
    selectorSizeLabel: "Размеры продукта",
    selectorSizePlaceholder: "Введите размеры",
    selectorSizeHint: "напр.: 20×30 см, A3, A2, диаметр 80 мм",
    selectorOutputLabel: "Ожидаемый суточный выпуск?",
    selectorOutput1: "1–50 шт.",
    selectorOutput2: "50–200 шт.",
    selectorOutput3: "200–500 шт.",
    selectorOutput4: "500–1 000 шт.",
    selectorOutput5: "Более 1 000 шт.",
    selectorBudgetLabel: "Бюджет?",
    selectorBudget1: "До 3 000 USD",
    selectorBudget2: "3 000–6 000 USD",
    selectorBudget3: "6 000–10 000 USD",
    selectorBudget4: "Свыше 10 000 USD",
    selectorBudget5: "Пока не определён",
    selectorSelectPlaceholder: "Выберите",
    selectorSubmit: "Получить рекомендацию",
    selectorSubmitting: "Отправка…",
    selectorSubmitError: "Не удалось отправить. Попробуйте позже или свяжитесь с нами.",
    selectorTrustBadge: "Нам доверяют клиенты из 172 стран",
    selectorTrustDelivered: "53 000+ принтеров поставлено по всему миру",
    selectorSuccessTitle: "Спасибо!",
    selectorSuccessDesc: "Наш консультант свяжется с вами в течение 30 минут.",
    selectorSuccessReceive: "Вы получите:",
    selectorSuccessItem1: "Рекомендуемая модель принтера",
    selectorSuccessItem2: "Рекомендации по конфигурации",
    selectorSuccessItem3: "Примеры применения",
    selectorSuccessItem4: "Оценка доставки",
    selectorSuccessItem5: "Котировка",
    selectorClose: "Закрыть",
  },
  ko: {
    selectorTrigger: "맞춤 프린팅 솔루션 받기",
    selectorFabTeaserTitle: "어떤 프린터를 선택할지 고민되시나요?",
    selectorFabTeaserSubtitle: "30분 내 추천을 받으세요",
    selectorFabTeaserCta: "지금 시작하기",
    selectorTitle: "비즈니스에 맞는 프린터를 찾아보세요",
    selectorSubtitle:
      "용도, 생산량, 예산을 알려주시면,\n30분 내 전문가가 가장 적합한 솔루션을 추천해 드립니다.",
    selectorProductLabel: "어떤 제품을 인쇄하고 싶으신가요?",
    selectorProductPlaceholder: "제품 유형 입력",
    selectorProductHint:
      "예: 휴대폰 케이스, 텀블러, 유리, 아크릴, 금속, 여행가방",
    selectorSizeLabel: "제품 치수",
    selectorSizePlaceholder: "치수 입력",
    selectorSizeHint: "예: 20×30cm, A3, A2, 직경 80mm",
    selectorOutputLabel: "예상 일일 생산량?",
    selectorOutput1: "1–50개",
    selectorOutput2: "50–200개",
    selectorOutput3: "200–500개",
    selectorOutput4: "500–1,000개",
    selectorOutput5: "1,000개 이상",
    selectorBudgetLabel: "예산 범위?",
    selectorBudget1: "3,000 USD 이하",
    selectorBudget2: "3,000–6,000 USD",
    selectorBudget3: "6,000–10,000 USD",
    selectorBudget4: "10,000 USD 이상",
    selectorBudget5: "아직 미정",
    selectorSelectPlaceholder: "선택하세요",
    selectorSubmit: "추천 받기",
    selectorSubmitting: "제출 중…",
    selectorSubmitError: "제출에 실패했습니다. 나중에 다시 시도하거나 문의해 주세요.",
    selectorTrustBadge: "172개국 고객이 신뢰합니다",
    selectorTrustDelivered: "53,000+대 프린터 전 세계 배송",
    selectorSuccessTitle: "감사합니다!",
    selectorSuccessDesc: "담당 컨설턴트가 30분 내 연락드립니다.",
    selectorSuccessReceive: "다음을 받으실 수 있습니다:",
    selectorSuccessItem1: "추천 프린터 모델",
    selectorSuccessItem2: "구성 제안",
    selectorSuccessItem3: "적용 사례",
    selectorSuccessItem4: "배송비 견적",
    selectorSuccessItem5: "견적",
    selectorClose: "닫기",
  },
  ja: {
    selectorTrigger: "専用プリントソリューションを入手",
    selectorFabTeaserTitle: "プリンターの選び方でお困りですか？",
    selectorFabTeaserSubtitle: "30分以内におすすめをご提案",
    selectorFabTeaserCta: "今すぐ始める",
    selectorTitle: "ビジネスに最適なプリンターを見つける",
    selectorSubtitle:
      "用途、生産量、予算をお知らせください。\n30分以内に専門家が最適なソリューションをご提案します。",
    selectorProductLabel: "どの製品を印刷されたいですか？",
    selectorProductPlaceholder: "製品タイプを入力",
    selectorProductHint:
      "例：スマホケース、タンブラー、ガラス、アクリル、金属、スーツケース",
    selectorSizeLabel: "製品サイズ",
    selectorSizePlaceholder: "サイズを入力",
    selectorSizeHint: "例：20×30cm、A3、A2、直径80mm",
    selectorOutputLabel: "予想日産量は？",
    selectorOutput1: "1～50個",
    selectorOutput2: "50～200個",
    selectorOutput3: "200～500個",
    selectorOutput4: "500～1,000個",
    selectorOutput5: "1,000個以上",
    selectorBudgetLabel: "予算範囲は？",
    selectorBudget1: "3,000ドル以内",
    selectorBudget2: "3,000～6,000ドル",
    selectorBudget3: "6,000～10,000ドル",
    selectorBudget4: "10,000ドル以上",
    selectorBudget5: "未定",
    selectorSelectPlaceholder: "選択してください",
    selectorSubmit: "おすすめを取得",
    selectorSubmitting: "送信中…",
    selectorSubmitError: "送信に失敗しました。しばらくしてから再試行するか、お問い合わせください。",
    selectorTrustBadge: "172か国のお客様にご利用いただいています",
    selectorTrustDelivered: "53,000台以上のプリンターを世界に納品",
    selectorSuccessTitle: "ありがとうございます！",
    selectorSuccessDesc: "担当者が30分以内にご連絡いたします。",
    selectorSuccessReceive: "以下をお届けします：",
    selectorSuccessItem1: "おすすめプリンターモデル",
    selectorSuccessItem2: "構成のご提案",
    selectorSuccessItem3: "適用事例",
    selectorSuccessItem4: "送料見積もり",
    selectorSuccessItem5: "見積もり",
    selectorClose: "閉じる",
  },
  th: {
    selectorTrigger: "รับโซลูชันการพิมพ์ของคุณ",
    selectorFabTeaserTitle: "ต้องการความช่วยเหลือในการเลือกเครื่องพิมพ์?",
    selectorFabTeaserSubtitle: "รับคำแนะนำภายใน 30 นาที",
    selectorFabTeaserCta: "เริ่มเลย",
    selectorTitle: "ค้นหาเครื่องพิมพ์ที่เหมาะกับธุรกิจของคุณ",
    selectorSubtitle:
      "บอกการใช้งาน ปริมาณการผลิต และงบประมาณของคุณ\nและผู้เชี่ยวชาญของเราจะแนะนำโซลูชันที่เหมาะสมที่สุดภายใน 30 นาที",
    selectorProductLabel: "คุณต้องการพิมพ์สินค้าอะไร?",
    selectorProductPlaceholder: "กรอกประเภทสินค้า",
    selectorProductHint:
      "เช่น เคสมือถือ แก้วเก็บความเย็น แก้ว อะคริลิก โลหะ กระเป๋าเดินทาง",
    selectorSizeLabel: "ขนาดสินค้า",
    selectorSizePlaceholder: "กรอกขนาด",
    selectorSizeHint: "เช่น 20×30 ซม. A3 A2 เส้นผ่านศูนย์กลาง 80 มม.",
    selectorOutputLabel: "ปริมาณผลิตต่อวันโดยประมาณ?",
    selectorOutput1: "1–50 ชิ้น",
    selectorOutput2: "50–200 ชิ้น",
    selectorOutput3: "200–500 ชิ้น",
    selectorOutput4: "500–1,000 ชิ้น",
    selectorOutput5: "มากกว่า 1,000 ชิ้น",
    selectorBudgetLabel: "ช่วงงบประมาณ?",
    selectorBudget1: "ต่ำกว่า 3,000 USD",
    selectorBudget2: "3,000–6,000 USD",
    selectorBudget3: "6,000–10,000 USD",
    selectorBudget4: "มากกว่า 10,000 USD",
    selectorBudget5: "ยังไม่ตัดสินใจ",
    selectorSelectPlaceholder: "กรุณาเลือก",
    selectorSubmit: "รับคำแนะนำ",
    selectorSubmitting: "กำลังส่ง…",
    selectorSubmitError: "ส่งไม่สำเร็จ โปรดลองใหม่ภายหลังหรือติดต่อเรา",
    selectorTrustBadge: "ได้รับความไว้วางใจจากลูกค้าใน 172 ประเทศ",
    selectorTrustDelivered: "ส่งมอบเครื่องพิมพ์กว่า 53,000 เครื่องทั่วโลก",
    selectorSuccessTitle: "ขอบคุณ!",
    selectorSuccessDesc: "ที่ปรึกษาของเราจะติดต่อภายใน 30 นาที",
    selectorSuccessReceive: "คุณจะได้รับ:",
    selectorSuccessItem1: "รุ่นเครื่องพิมพ์ที่แนะนำ",
    selectorSuccessItem2: "คำแนะนำการกำหนดค่า",
    selectorSuccessItem3: "ตัวอย่างการใช้งาน",
    selectorSuccessItem4: "ประมาณการค่าขนส่ง",
    selectorSuccessItem5: "ใบเสนอราคา",
    selectorClose: "ปิด",
  },
  tr: {
    selectorTrigger: "Baskı çözümünüzü alın",
    selectorFabTeaserTitle: "Yazıcı seçiminde yardıma mı ihtiyacınız var?",
    selectorFabTeaserSubtitle: "30 dakika içinde öneri alın",
    selectorFabTeaserCta: "Hemen başla",
    selectorTitle: "İşletmeniz için doğru yazıcıyı bulun",
    selectorSubtitle:
      "Uygulamanızı, üretim hacminizi ve bütçenizi paylaşın,\nuzmanlarımız 30 dakika içinde en uygun çözümü önersin.",
    selectorProductLabel: "Hangi ürünleri yazdırmak istersiniz?",
    selectorProductPlaceholder: "Ürün türünü girin",
    selectorProductHint:
      "örn.: telefon kılıfları, termoslar, cam, akrilik, metal, bavul",
    selectorSizeLabel: "Ürün boyutları",
    selectorSizePlaceholder: "Boyutları girin",
    selectorSizeHint: "örn.: 20×30 cm, A3, A2, 80 mm çap",
    selectorOutputLabel: "Tahmini günlük üretim?",
    selectorOutput1: "1–50 adet",
    selectorOutput2: "50–200 adet",
    selectorOutput3: "200–500 adet",
    selectorOutput4: "500–1.000 adet",
    selectorOutput5: "1.000+ adet",
    selectorBudgetLabel: "Bütçe aralığı?",
    selectorBudget1: "3.000 USD altı",
    selectorBudget2: "3.000–6.000 USD",
    selectorBudget3: "6.000–10.000 USD",
    selectorBudget4: "10.000 USD üzeri",
    selectorBudget5: "Henüz belirlenmedi",
    selectorSelectPlaceholder: "Seçiniz",
    selectorSubmit: "Öneri al",
    selectorSubmitting: "Gönderiliyor…",
    selectorSubmitError: "Gönderim başarısız. Lütfen daha sonra tekrar deneyin veya bizimle iletişime geçin.",
    selectorTrustBadge: "172 ülkedeki müşteriler tarafından güveniliyor",
    selectorTrustDelivered: "Dünya çapında 53.000+ yazıcı teslim edildi",
    selectorSuccessTitle: "Teşekkürler!",
    selectorSuccessDesc: "Danışmanımız 30 dakika içinde sizinle iletişime geçecek.",
    selectorSuccessReceive: "Şunları alacaksınız:",
    selectorSuccessItem1: "Önerilen yazıcı modeli",
    selectorSuccessItem2: "Yapılandırma önerileri",
    selectorSuccessItem3: "Uygulama örnekleri",
    selectorSuccessItem4: "Kargo tahmini",
    selectorSuccessItem5: "Teklif",
    selectorClose: "Kapat",
  },
  vi: {
    selectorTrigger: "Nhận giải pháp in ấn của bạn",
    selectorFabTeaserTitle: "Cần giúp chọn máy in?",
    selectorFabTeaserSubtitle: "Nhận đề xuất trong 30 phút",
    selectorFabTeaserCta: "Bắt đầu ngay",
    selectorTitle: "Tìm máy in phù hợp cho doanh nghiệp của bạn",
    selectorSubtitle:
      "Cho chúng tôi biết ứng dụng, sản lượng và ngân sách của bạn,\nvà chuyên gia của chúng tôi sẽ đề xuất giải pháp phù hợp nhất trong 30 phút.",
    selectorProductLabel: "Bạn muốn in sản phẩm gì?",
    selectorProductPlaceholder: "Nhập loại sản phẩm",
    selectorProductHint:
      "vd: ốp điện thoại, bình giữ nhiệt, thủy tinh, acrylic, kim loại, vali",
    selectorSizeLabel: "Kích thước sản phẩm",
    selectorSizePlaceholder: "Nhập kích thước",
    selectorSizeHint: "vd: 20×30cm, A3, A2, đường kính 80mm",
    selectorOutputLabel: "Sản lượng ngày dự kiến?",
    selectorOutput1: "1–50 chiếc",
    selectorOutput2: "50–200 chiếc",
    selectorOutput3: "200–500 chiếc",
    selectorOutput4: "500–1.000 chiếc",
    selectorOutput5: "Trên 1.000 chiếc",
    selectorBudgetLabel: "Phạm vi ngân sách?",
    selectorBudget1: "Dưới 3.000 USD",
    selectorBudget2: "3.000–6.000 USD",
    selectorBudget3: "6.000–10.000 USD",
    selectorBudget4: "Trên 10.000 USD",
    selectorBudget5: "Chưa xác định",
    selectorSelectPlaceholder: "Vui lòng chọn",
    selectorSubmit: "Nhận đề xuất",
    selectorSubmitting: "Đang gửi…",
    selectorSubmitError: "Gửi thất bại. Vui lòng thử lại sau hoặc liên hệ chúng tôi.",
    selectorTrustBadge: "Được tin tưởng bởi khách hàng tại 172 quốc gia",
    selectorTrustDelivered: "53.000+ máy in đã giao trên toàn thế giới",
    selectorSuccessTitle: "Cảm ơn!",
    selectorSuccessDesc: "Tư vấn viên sẽ liên hệ trong 30 phút.",
    selectorSuccessReceive: "Bạn sẽ nhận được:",
    selectorSuccessItem1: "Mẫu máy in đề xuất",
    selectorSuccessItem2: "Gợi ý cấu hình",
    selectorSuccessItem3: "Mẫu ứng dụng",
    selectorSuccessItem4: "Ước tính vận chuyển",
    selectorSuccessItem5: "Báo giá",
    selectorClose: "Đóng",
  },
  nl: {
    selectorTrigger: "Ontvang uw printoplossing",
    selectorFabTeaserTitle: "Hulp nodig bij het kiezen van een printer?",
    selectorFabTeaserSubtitle: "Aanbeveling binnen 30 minuten",
    selectorFabTeaserCta: "Nu starten",
    selectorTitle: "Vind de juiste printer voor uw bedrijf",
    selectorSubtitle:
      "Vertel ons uw toepassing, productievolume en budget,\nen onze experts bevelen binnen 30 minuten de meest geschikte oplossing aan.",
    selectorProductLabel: "Welke producten wilt u printen?",
    selectorProductPlaceholder: "Voer producttype in",
    selectorProductHint:
      "bijv.: telefoonhoesjes, thermosbekers, glas, acryl, metaal, koffers",
    selectorSizeLabel: "Productafmetingen",
    selectorSizePlaceholder: "Voer afmetingen in",
    selectorSizeHint: "bijv.: 20×30 cm, A3, A2, 80 mm diameter",
    selectorOutputLabel: "Geschatte dagproductie?",
    selectorOutput1: "1–50 stuks",
    selectorOutput2: "50–200 stuks",
    selectorOutput3: "200–500 stuks",
    selectorOutput4: "500–1.000 stuks",
    selectorOutput5: "Meer dan 1.000 stuks",
    selectorBudgetLabel: "Budgetbereik?",
    selectorBudget1: "Onder USD 3.000",
    selectorBudget2: "USD 3.000–6.000",
    selectorBudget3: "USD 6.000–10.000",
    selectorBudget4: "Boven USD 10.000",
    selectorBudget5: "Nog niet bepaald",
    selectorSelectPlaceholder: "Selecteer",
    selectorSubmit: "Aanbeveling ontvangen",
    selectorSubmitting: "Bezig met verzenden…",
    selectorSubmitError: "Verzenden mislukt. Probeer het later opnieuw of neem contact op.",
    selectorTrustBadge: "Vertrouwd door klanten in 172 landen",
    selectorTrustDelivered: "53.000+ printers wereldwijd geleverd",
    selectorSuccessTitle: "Bedankt!",
    selectorSuccessDesc: "Onze adviseur neemt binnen 30 minuten contact met u op.",
    selectorSuccessReceive: "U ontvangt:",
    selectorSuccessItem1: "Aanbevolen printermodel",
    selectorSuccessItem2: "Configuratiesuggesties",
    selectorSuccessItem3: "Toepassingsvoorbeelden",
    selectorSuccessItem4: "Verzendkostenraming",
    selectorSuccessItem5: "Offerte",
    selectorClose: "Sluiten",
  },
  id: {
    selectorTrigger: "Dapatkan solusi printing Anda",
    selectorFabTeaserTitle: "Butuh bantuan memilih printer?",
    selectorFabTeaserSubtitle: "Rekomendasi dalam 30 menit",
    selectorFabTeaserCta: "Mulai sekarang",
    selectorTitle: "Temukan printer yang tepat untuk bisnis Anda",
    selectorSubtitle:
      "Ceritakan aplikasi, volume produksi, dan anggaran Anda,\ndan pakar kami akan merekomendasikan solusi terbaik dalam 30 menit.",
    selectorProductLabel: "Produk apa yang ingin Anda cetak?",
    selectorProductPlaceholder: "Masukkan jenis produk",
    selectorProductHint:
      "mis.: casing HP, tumbler, kaca, akrilik, logam, koper",
    selectorSizeLabel: "Dimensi produk",
    selectorSizePlaceholder: "Masukkan dimensi",
    selectorSizeHint: "mis.: 20×30 cm, A3, A2, diameter 80 mm",
    selectorOutputLabel: "Perkiraan produksi harian?",
    selectorOutput1: "1–50 pcs",
    selectorOutput2: "50–200 pcs",
    selectorOutput3: "200–500 pcs",
    selectorOutput4: "500–1.000 pcs",
    selectorOutput5: "Lebih dari 1.000 pcs",
    selectorBudgetLabel: "Kisaran anggaran?",
    selectorBudget1: "Di bawah USD 3.000",
    selectorBudget2: "USD 3.000–6.000",
    selectorBudget3: "USD 6.000–10.000",
    selectorBudget4: "Di atas USD 10.000",
    selectorBudget5: "Belum ditentukan",
    selectorSelectPlaceholder: "Silakan pilih",
    selectorSubmit: "Dapatkan rekomendasi",
    selectorSubmitting: "Mengirim…",
    selectorSubmitError: "Pengiriman gagal. Coba lagi nanti atau hubungi kami.",
    selectorTrustBadge: "Dipercaya pelanggan di 172 negara",
    selectorTrustDelivered: "53.000+ printer dikirim ke seluruh dunia",
    selectorSuccessTitle: "Terima kasih!",
    selectorSuccessDesc: "Konsultan kami akan menghubungi Anda dalam 30 menit.",
    selectorSuccessReceive: "Anda akan menerima:",
    selectorSuccessItem1: "Model printer yang direkomendasikan",
    selectorSuccessItem2: "Saran konfigurasi",
    selectorSuccessItem3: "Contoh aplikasi",
    selectorSuccessItem4: "Estimasi pengiriman",
    selectorSuccessItem5: "Penawaran harga",
    selectorClose: "Tutup",
  },
  ar: {
    selectorTrigger: "احصل على حل الطباعة الخاص بك",
    selectorFabTeaserTitle: "هل تحتاج مساعدة في اختيار الطابعة؟",
    selectorFabTeaserSubtitle: "احصل على توصية خلال 30 دقيقة",
    selectorFabTeaserCta: "ابدأ الآن",
    selectorTitle: "اعثر على الطابعة المناسبة لعملك",
    selectorSubtitle:
      "أخبرنا بتطبيقك وحجم الإنتاج والميزانية،\nوسيوصي خبراؤنا بالحل الأنسب خلال 30 دقيقة.",
    selectorProductLabel: "ما المنتجات التي ترغب في طباعتها؟",
    selectorProductPlaceholder: "أدخل نوع المنتج",
    selectorProductHint:
      "مثل: أغطية الهاتف، أكواب حرارية، زجاج، أكريليك، معدن، حقائب",
    selectorSizeLabel: "أبعاد المنتج",
    selectorSizePlaceholder: "أدخل الأبعاد",
    selectorSizeHint: "مثل: 20×30 سم، A3، A2، قطر 80 مم",
    selectorOutputLabel: "الإنتاج اليومي المتوقع؟",
    selectorOutput1: "1–50 قطعة",
    selectorOutput2: "50–200 قطعة",
    selectorOutput3: "200–500 قطعة",
    selectorOutput4: "500–1,000 قطعة",
    selectorOutput5: "أكثر من 1,000 قطعة",
    selectorBudgetLabel: "نطاق الميزانية؟",
    selectorBudget1: "أقل من 3,000 دولار",
    selectorBudget2: "3,000–6,000 دولار",
    selectorBudget3: "6,000–10,000 دولار",
    selectorBudget4: "أكثر من 10,000 دولار",
    selectorBudget5: "لم يُحدد بعد",
    selectorSelectPlaceholder: "يرجى الاختيار",
    selectorSubmit: "احصل على التوصية",
    selectorSubmitting: "جاري الإرسال…",
    selectorSubmitError: "فشل الإرسال. يُرجى المحاولة لاحقًا أو التواصل معنا.",
    selectorTrustBadge: "موثوق به من قبل عملاء في 172 دولة",
    selectorTrustDelivered: "53,000+ طابعة تم تسليمها حول العالم",
    selectorSuccessTitle: "شكراً لك!",
    selectorSuccessDesc: "سيتواصل معك مستشارنا خلال 30 دقيقة.",
    selectorSuccessReceive: "ستحصل على:",
    selectorSuccessItem1: "طراز الطابعة الموصى به",
    selectorSuccessItem2: "اقتراحات التكوين",
    selectorSuccessItem3: "عينات التطبيق",
    selectorSuccessItem4: "تقدير الشحن",
    selectorSuccessItem5: "عرض السعر",
    selectorClose: "إغلاق",
  },
  pl: {
    selectorTrigger: "Odbierz swoje rozwiązanie druku",
    selectorFabTeaserTitle: "Potrzebujesz pomocy w wyborze drukarki?",
    selectorFabTeaserSubtitle: "Rekomendacja w 30 minut",
    selectorFabTeaserCta: "Zacznij teraz",
    selectorTitle: "Znajdź odpowiednią drukarkę dla swojej firmy",
    selectorSubtitle:
      "Opisz zastosowanie, wolumen produkcji i budżet,\na nasi eksperci w ciągu 30 minut zarekomendują najlepsze rozwiązanie.",
    selectorProductLabel: "Jakie produkty chciałbyś drukować?",
    selectorProductPlaceholder: "Wpisz typ produktu",
    selectorProductHint:
      "np.: etui, kubki termiczne, szkło, akryl, metal, walizki",
    selectorSizeLabel: "Wymiary produktu",
    selectorSizePlaceholder: "Wpisz wymiary",
    selectorSizeHint: "np.: 20×30 cm, A3, A2, średnica 80 mm",
    selectorOutputLabel: "Szacowana produkcja dzienna?",
    selectorOutput1: "1–50 szt.",
    selectorOutput2: "50–200 szt.",
    selectorOutput3: "200–500 szt.",
    selectorOutput4: "500–1 000 szt.",
    selectorOutput5: "Ponad 1 000 szt.",
    selectorBudgetLabel: "Zakres budżetu?",
    selectorBudget1: "Poniżej 3 000 USD",
    selectorBudget2: "3 000–6 000 USD",
    selectorBudget3: "6 000–10 000 USD",
    selectorBudget4: "Powyżej 10 000 USD",
    selectorBudget5: "Jeszcze nie ustalono",
    selectorSelectPlaceholder: "Wybierz",
    selectorSubmit: "Uzyskaj rekomendację",
    selectorSubmitting: "Wysyłanie…",
    selectorSubmitError: "Wysyłanie nie powiodło się. Spróbuj ponownie później lub skontaktuj się z nami.",
    selectorTrustBadge: "Zaufali nam klienci w 172 krajach",
    selectorTrustDelivered: "53 000+ drukarek dostarczonych na całym świecie",
    selectorSuccessTitle: "Dziękujemy!",
    selectorSuccessDesc: "Nasz konsultant skontaktuje się w ciągu 30 minut.",
    selectorSuccessReceive: "Otrzymasz:",
    selectorSuccessItem1: "Rekomendowany model drukarki",
    selectorSuccessItem2: "Sugestie konfiguracji",
    selectorSuccessItem3: "Przykłady zastosowań",
    selectorSuccessItem4: "Szacunek wysyłki",
    selectorSuccessItem5: "Wycenę",
    selectorClose: "Zamknij",
  },
};
